import React, { useCallback, useState } from 'react'
import cn from 'classnames'
import styles from 'components/answers/answer-top-controls.module.scss'
import CopyLinkButton from 'components/shared/CopyLinkButton'
import { isMobile } from 'lib/device'
import perms from 'lib/perms'
import WithTooltip from 'components/shared/WithTooltip'
import usePanelContext from 'refactor/hooks/usePanelContext'
import {
    ArchiveButton,
    ConfirmArchive,
    canShareAnswer,
    launchAnswerShare,
} from 'components/answers/AnswerControls'
import { Share2 } from 'lucide-react'

export default function AnswerTopControls(props) {
    const answer = props.answer
    const { hide } = usePanelContext()

    const onClick = ev => {
        ev.stopPropagation()
    }

    // Share swapped places with Star: star lives in the ⋮ menu now, share
    // gets the always-visible top slot on public threads.
    const showShare =
        !props.systemQuoteNoti && perms.isPublic(props.quest) && canShareAnswer(answer)

    const onShareClick = ev => {
        ev.preventDefault()
        ev.stopPropagation()

        launchAnswerShare({
            answer,
            copyContent: props.copyContent,
            getPublicLink: props.getPublicLink,
            openShareTray: props.openShareTray,
        })
    }

    const visibleStyles = !hide && (props.isBsv || isMobile || props.hover) ? styles.visible : null

    const toggleControlsPopup = useCallback(ev => {
        ev.stopPropagation()
        props.toggleControlsPopup()
    }, [])

    const isBsv = props.isBsv

    return (
        <div
            className={cn(styles.answerTopControlsComp, visibleStyles, styles.thin)}
            data-answer-top-controls-visible={!!visibleStyles}
            onClick={onClick}
        >
            {!isBsv && gon.currentUser && perms.canEditAnswer(gon.currentUser, answer) && (
                <div className={cn(styles.topControlContainer)}>
                    <WithTooltip asChild tip={props.editMode ? 'Editing post.' : 'Edit post.'}>
                        <div
                            className={cn(styles.topControl, props.editMode && styles.editMode)}
                            data-testid="answer-edit-button"
                            onClick={props.toggleEdit}
                        >
                            <i className={`fa ${props.editMode ? 'fa-edit' : 'fa-edit'} fa-lg`} />
                        </div>
                    </WithTooltip>
                </div>
            )}

            {showShare && (
                <div className={cn(styles.topControlContainer)}>
                    <WithTooltip tip="Share this post.">
                        <div
                            className={cn(styles.topControl, styles.shareControl)}
                            data-testid="answer-share-top-button"
                            onClick={onShareClick}
                        >
                            <Share2 size={14} />
                        </div>
                    </WithTooltip>
                </div>
            )}

            <div className={cn(styles.topControlContainer)}>
                <div className={cn(styles.topControl, styles.copyLinkControl)}>
                    <CopyLinkButton
                        tooltip
                        getPublicLink={props.getPublicLink}
                        isMobile={isMobile}
                        styles={styles}
                        showLabel={false}
                        testId="answer-copy-link-top-button"
                    />
                </div>
            </div>

            {props.showControlsMenu !== false && (
                <div className={cn(styles.topControlContainer)}>
                    <WithTooltip
                        asChild
                        tip={props.showControlsPopup ? 'Close controls.' : 'More controls.'}
                    >
                        <div
                            className={cn(styles.topControl)}
                            data-testid="answer-controls-menu-button"
                            onClick={toggleControlsPopup}
                        >
                            {props.showControlsPopup ? (
                                <i className="fa fa-remove fa-lg" />
                            ) : (
                                <i className="fa fa-ellipsis-h fa-lg" />
                            )}
                        </div>
                    </WithTooltip>
                </div>
            )}
        </div>
    )
}
